(function () {
  function isPlaceholderEmail(email) {
    if (!email) return true;
    return (
      email.indexOf('@customers.audkenni.shop') !== -1 ||
      email.indexOf('@audkenni.placeholder') !== -1
    );
  }

  function resolveCustomerEmail(config) {
    if (config.customerNotifyEmail) return config.customerNotifyEmail;
    if (config.customerEmail && !isPlaceholderEmail(config.customerEmail)) {
      return config.customerEmail;
    }
    return '';
  }

  function resolveCustomerLabel(config) {
    var email = resolveCustomerEmail(config);
    if (email) return email;
    if (config.customerName) return config.customerName;
    if (config.customerId) return 'Notandi #' + config.customerId;
    return 'Óþekktur notandi';
  }

  function getSectionConfig(sectionEl) {
    return {
      enabled: sectionEl.dataset.notifyEnabled === 'true',
      method: sectionEl.dataset.notifyMethod || 'shopify_contact',
      appUrl: (sectionEl.dataset.appUrl || '').replace(/\/$/, ''),
      webhookUrl: sectionEl.dataset.webhookUrl || '',
      notifyEmail: sectionEl.dataset.notifyEmail || 'islandshus@islandshus.is',
      shop: sectionEl.dataset.shop || '',
      pageTitle: sectionEl.dataset.pageTitle || '',
      pageUrl: sectionEl.dataset.pageUrl || window.location.href,
      customerId: sectionEl.dataset.customerId || '',
      customerEmail: sectionEl.dataset.customerEmail || '',
      customerNotifyEmail: sectionEl.dataset.customerNotifyEmail || '',
      customerEmailIsPlaceholder: sectionEl.dataset.customerEmailIsPlaceholder === 'true',
      customerName: sectionEl.dataset.customerName || '',
      customerOrg: sectionEl.dataset.customerOrg || ''
    };
  }

  function buildPayload(config, fileName, fileUrl) {
    var customerEmail = resolveCustomerEmail(config);

    return {
      shop: config.shop,
      notifyTo: config.notifyEmail,
      customer: {
        id: config.customerId,
        email: customerEmail,
        shopifyEmail: config.customerEmail,
        name: config.customerName,
        organization: config.customerOrg,
        emailIsPlaceholder: config.customerEmailIsPlaceholder && !customerEmail
      },
      file: {
        name: fileName,
        url: fileUrl
      },
      page: {
        title: config.pageTitle,
        url: config.pageUrl
      },
      downloadedAt: new Date().toISOString()
    };
  }

  function buildContactBody(config, fileName, fileUrl) {
    var customerEmail = resolveCustomerEmail(config);
    var customerLabel = config.customerName || 'Óþekktur notandi';
    var downloadedAt = new Date().toLocaleString('is-IS', { timeZone: 'Atlantic/Reykjavik' });
    var lines = [
      'TEIKNING SÓTT',
      '',
      'NETFANG NOTANDA: ' + (customerEmail || 'EKKI SKRÁÐ'),
      'Nafn: ' + customerLabel
    ];

    if (config.customerOrg) {
      lines.push('Fyrirtæki: ' + config.customerOrg);
    }

    lines.push('Customer ID: ' + (config.customerId || '—'));

    if (config.customerEmailIsPlaceholder && !customerEmail) {
      lines.push('Athugasemd: Notandi er skráður inn með Auðkenni en hefur ekki skráð raunverulegt netfang.');
    }

    if (config.customerEmail && config.customerEmail !== customerEmail) {
      lines.push('Shopify netfang (placeholder): ' + config.customerEmail);
    }

    lines.push(
      '',
      'Skrá: ' + fileName,
      'Slóð á skrá: ' + fileUrl,
      'Síða: ' + config.pageTitle,
      'Vefslóð: ' + config.pageUrl,
      '',
      'Tími: ' + downloadedAt
    );

    return lines.join('\n');
  }

  function buildContactSubject(config, fileName) {
    var customerEmail = resolveCustomerEmail(config);
    var who = customerEmail || resolveCustomerLabel(config);
    return 'Teikning sótt af ' + who + ' — ' + fileName;
  }

  function getContactToken(sectionEl) {
    var tokenInput = sectionEl.querySelector('input[name="authenticity_token"]');
    return tokenInput ? tokenInput.value : '';
  }

  function notifyViaShopifyContact(sectionEl, config, fileName, fileUrl) {
    var formData = new FormData();
    var customerEmail = resolveCustomerEmail(config);
    var contactEmail = customerEmail || config.notifyEmail;

    formData.append('form_type', 'contact');
    formData.append('utf8', '\u2713');

    var token = getContactToken(sectionEl);
    if (token) formData.append('authenticity_token', token);

    formData.append('contact[email]', contactEmail);
    formData.append('contact[name]', config.customerName || 'Óþekktur notandi');
    formData.append('contact[subject]', buildContactSubject(config, fileName));
    formData.append('contact[body]', buildContactBody(config, fileName, fileUrl));

    return fetch('/contact#contact_form', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData,
      credentials: 'same-origin',
      keepalive: true
    }).then(function (res) {
      if (!res.ok && res.status !== 200 && res.status !== 302) {
        throw new Error('Contact notify failed');
      }
      return res;
    });
  }

  function notifyViaApp(config, payload) {
    if (!config.appUrl) return Promise.reject(new Error('Missing app URL'));

    return fetch(config.appUrl + '/api/teikningar/download-notify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload),
      credentials: 'omit',
      keepalive: true
    }).then(function (res) {
      if (!res.ok) throw new Error('App notify failed');
      return res;
    });
  }

  function notifyViaWebhook(config, payload) {
    if (!config.webhookUrl) return Promise.reject(new Error('Missing webhook URL'));

    return fetch(config.webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (res) {
      if (!res.ok) throw new Error('Webhook notify failed');
      return res;
    });
  }

  function sendNotification(sectionEl, fileName, fileUrl) {
    var config = getSectionConfig(sectionEl);
    if (!config.enabled) return;

    var payload = buildPayload(config, fileName, fileUrl);
    var method = config.method;
    var attempt;

    if (method === 'app') {
      attempt = notifyViaApp(config, payload).catch(function () {
        return notifyViaShopifyContact(sectionEl, config, fileName, fileUrl);
      });
    } else if (method === 'webhook') {
      attempt = notifyViaWebhook(config, payload).catch(function () {
        return notifyViaShopifyContact(sectionEl, config, fileName, fileUrl);
      });
    } else {
      attempt = notifyViaShopifyContact(sectionEl, config, fileName, fileUrl);
    }

    attempt.catch(function () {
      /* Silent fail – download should still proceed */
    });
  }

  function initSection(sectionEl) {
    sectionEl.querySelectorAll('[data-file-download-track]').forEach(function (btn) {
      if (btn.dataset.notifyBound === 'true') return;
      btn.dataset.notifyBound = 'true';

      btn.addEventListener('click', function () {
        var fileName = btn.dataset.fileName || '';
        var fileUrl = btn.dataset.fileUrl || btn.getAttribute('href') || '';
        sendNotification(sectionEl, fileName, fileUrl);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-file-download-notify]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
